export const PLAN_CATEGORIES = ['All General Pests', 'Interior & Exterior', 'Eaves', 'Re-services at no cost', 'Foundation'];
